import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Button,
    Breadcrumb,
    Grid,
    Table,
    Modal,
    Input,
    Card,
    Message,
    Form,
    Select,
    Image as ImageSemantic,
    Label
} from 'semantic-ui-react';
import FontPicker from "font-picker-react";
import CustomDivider from '../../components/extras/CustomDivider';
import {SketchPicker} from "react-color";
import connect from "react-redux/es/connect/connect";
import helpers from "../../functions/helpers";
import {showToast} from "../../actions/ToastAction";
import Loading from "../../components/extras/Loading";
import CheckPermission from "../../components/extras/CheckPermission";
import QRCode from "react-qr-code";
import QuickMenuData from "../../data/QuickMenuData";
import ColorPickerStyles from "../../utils/color_picker_styles";
import BranchOfficeData from "../../data/BranchOfficeData";

let GLOBAL = require('../../data/globals');


class QuickMenu extends Component {
    constructor() {
        super();
        this.state = {
            modal_web_address: false,
            loading: true,
            branch_offices: [],
            data:{
                slug: '',
                icon_url: '',
                main_color: '',
                text_color: '',
                background_color: '',
                favicon: '',
                icon_256_256: '',
                icon_512_512: '',
                is_active: false
            },
            branch_office: {
                id: '',
                name: ''
            },
            slug:'',
            domain: '',
            color_picker_main_color: false,
            color_picker_background_color: false,
            color_picker_text_color: false,
            saving: false,
            uploading_icon: false,
            saving_slug: false,
            saving_domain: false,
            modal_domain: false
        }
        this.file_icon = React.createRef();
        this.handleSelectIcon = this.handleSelectIcon.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    handleBranchOfficeChange = async (result) => {
        this.setState({branch_office: {id: result, name: result}});
        this.getData(result)
    };

    async initialFetch() {
        await BranchOfficeData.listAll().then(branch_offices =>{
            this.setState({branch_offices});
            this.handleBranchOfficeChange(branch_offices[0].key)
        });

    };

    getData = async (branch_office) => {
        await QuickMenuData.get(branch_office,data => {
            if(data.hasOwnProperty('id')){
                this.setState({data})
            }
        }).finally(() => this.setState({loading: false}))
    }

    toggleModalSlug = () =>{
        this.setState({
            modal_web_address: !this.state.modal_web_address,
            slug: this.state.data.slug
        });
    };

    toggleModalDomain = () =>{
        this.setState({
            modal_domain: !this.state.modal_domain,
            domain: this.state.data.domain ? this.state.data.domain.replace(/(^\w+:|^)\/\//, ''):''
        });
    };

    handleToggleColorPicker = (picker_selected) => {
        this.setState({ [picker_selected]: !this.state[picker_selected] })
    };

    saveDesign = () =>{
        let data = {...this.state.data}
        delete data.icon

        this.saveData(data, 'saving', ()=>{})
    }

    saveData = (data, saving, func) => {
        this.setState({[saving]: true})
        QuickMenuData.patch(this.state.branch_office.id, data, res => {
            if(res.update){
                this.setState({data: res.data})
                this.props.showToast({ message: 'Información actualizada!', type: 'success' });
                func()
            }else{
                let keys = Object.keys(res.errors)
                keys.map((key) => this.props.showToast({ message: res.errors[key][0], type: 'error' }))
            }
        }).finally(() => this.setState({[saving]: false}))
    }

    saveSlug = () =>{
        let data = {slug:this.state.slug}
        this.saveData(data, 'saving_slug', this.toggleModalSlug)
    }

    saveDomain = () =>{
        let data = {domain:this.state.domain.trim() ? `https://${this.state.domain.trim()}`:''}
        this.saveData(data, 'saving_domain', this.toggleModalDomain)
    }

    handleChangeColor = (color, name) => {
        this.setState({
            data: {
                ...this.state.data,
                [name]: color.hex,
            }
        });
    };

    handleChangeFont = (font, name) => {
        this.setState({
            data: {
                ...this.state.data,
                [name]: font,
            }
        });
    };

    handleChangeSlug = (e, { name, value }) => {
        this.setState({[name]: helpers.slugify(value)});
    };

    downloadQrCode = () => {
        const svg = document.getElementById("QRCode");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const pngFile = canvas.toDataURL("image/png");
            const downloadLink = document.createElement("a");
            downloadLink.download = "QRCode";
            downloadLink.href = `${pngFile}`;
            downloadLink.click();
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    };

    handleSelectIcon(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({uploading_icon: true})
            QuickMenuData.changeIcon(this.state.branch_office.id, {icon: reader.result}, res => {
                if(res.update){
                    this.setState({data: res.data})
                    this.props.showToast({ message: 'Icono actualizado!', type: 'success' });
                }else{
                    let keys = Object.keys(res.errors)
                    keys.map((key) => this.props.showToast({ message: res.errors[key][0], type: 'error' }))
                }
            }).finally(() => this.setState({uploading_icon: false}))
        };
        reader.readAsDataURL(file);
    }

    handleChangeLogo = () => {
        this.file_icon.current.click();
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quick Menú | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Quick Menú</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid>
                    {!this.state.loading ?<Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Table celled>
                                <Table.Row>
                                    <Table.Cell>
                                        <Form>
                                            <Form.Field inline>
                                                <Select options={this.state.branch_offices}
                                                        fluid
                                                        onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                        value={this.state.branch_office.id} placeholder='Sucursal' />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                </Table.Row>
                            </Table>

                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={3} textAlign='center'>Configuraciones</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><strong>Dirección Web</strong></Table.Cell>
                                        <Table.Cell>
                                            <a href={`https://${this.state.data.slug}.bisttros.menu`} target='_blank'>{`${this.state.data.slug}.bisttros.menu`}</a>
                                            </Table.Cell>
                                        <Table.Cell>
                                            <Button.Group basic size='tiny'>
                                                <Button icon='pencil' onClick={this.toggleModalSlug}/>
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Dominio</strong></Table.Cell>
                                        <Table.Cell>
                                            <a href={this.state.data.domain} target='_blank'>{this.state.data.domain}</a>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button.Group basic size='tiny'>
                                                <Button icon='pencil' onClick={this.toggleModalDomain}/>
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>

                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={3} textAlign='center'>Icono</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><strong>Icono (512x512 pixeles)</strong></Table.Cell>
                                        <Table.Cell style={{textAlign:'center'}}>
                                            <input
                                                ref={this.file_icon}
                                                type="file"
                                                style={{"display": "none"}}
                                                accept=".png, .jpg, .jpeg"
                                                onChange={this.handleSelectIcon}
                                            />
                                            <ImageSemantic src={this.state.data.icon_url} size='small' verticalAlign='middle' style={{marginBottom:'1em'}}/>
                                            <Button primary fluid disabled={this.state.uploading_icon} loading={this.state.uploading_icon} content="Cambiar Icono" onClick={this.handleChangeLogo}/>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>

                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={3} textAlign='center'>Diseño</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><strong>Color Principal</strong></Table.Cell>
                                        <Table.Cell>
                                            <div>
                                                <div style={ Object.assign({}, ColorPickerStyles.swatch, {'background':this.state.data.main_color}) } onClick={() => this.handleToggleColorPicker('color_picker_main_color') }>
                                                    <div style={ ColorPickerStyles.color } />
                                                </div>
                                                { this.state.color_picker_main_color ? <div style={ ColorPickerStyles.popover }>
                                                    <div style={ ColorPickerStyles.cover } onClick={() => this.handleToggleColorPicker('color_picker_main_color') }/>
                                                    <SketchPicker color={ this.state.data.main_color } name={'main_color'} onChange={(color) => this.handleChangeColor(color, 'main_color') } />
                                                </div> : null }
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Color de Fondo</strong></Table.Cell>
                                        <Table.Cell>
                                            <div>
                                                <div style={ Object.assign({}, ColorPickerStyles.swatch, {'background':this.state.data.background_color}) } onClick={() => this.handleToggleColorPicker('color_picker_background_color') }>
                                                    <div style={ ColorPickerStyles.color } />
                                                </div>
                                                { this.state.color_picker_background_color ? <div style={ ColorPickerStyles.popover }>
                                                    <div style={ ColorPickerStyles.cover } onClick={() => this.handleToggleColorPicker('color_picker_background_color') }/>
                                                    <SketchPicker color={ this.state.data.background_color } name={'background_color'} onChange={(color) => this.handleChangeColor(color, 'background_color') } />
                                                </div> : null }
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Color de Texto</strong></Table.Cell>
                                        <Table.Cell>
                                            <div>
                                                <div style={ Object.assign({}, ColorPickerStyles.swatch, {'background':this.state.data.text_color}) } onClick={() => this.handleToggleColorPicker('color_picker_text_color') }>
                                                    <div style={ ColorPickerStyles.color } />
                                                </div>
                                                { this.state.color_picker_text_color ? <div style={ ColorPickerStyles.popover }>
                                                    <div style={ ColorPickerStyles.cover } onClick={() => this.handleToggleColorPicker('color_picker_text_color') }/>
                                                    <SketchPicker color={ this.state.data.text_color } name={'text_color'} onChange={(color) => this.handleChangeColor(color, 'text_color') } />
                                                </div> : null }
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Tipo de Letra para Títulos</strong></Table.Cell>
                                        <Table.Cell>
                                            <FontPicker
                                                apiKey={GLOBAL.API_KEY_FONT}
                                                limit={669}
                                                activeFontFamily={this.state.data.title_font}
                                                onChange={(font) => this.handleChangeFont(font.family, 'title_font')}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Tipo de Letra para textos</strong></Table.Cell>
                                        <Table.Cell>
                                            <FontPicker
                                                apiKey={GLOBAL.API_KEY_FONT}
                                                limit={669}
                                                activeFontFamily={this.state.data.text_font}
                                                onChange={(font) => this.handleChangeFont(font.family, 'text_font')}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell colSpan={2}>
                                            <strong>Preview</strong>
                                            <Card fluid style={{background:this.state.data.background_color}}>
                                                <Card.Content>
                                                    <Card.Header style={{color:this.state.data.main_color, fontFamily: this.state.data.title_font, fontSize:'16pt'}}>Título</Card.Header>
                                                    <Card.Description>
                                                        <hr style={{border:`0.5px solid ${this.state.data.main_color}`}}/>
                                                        <span style={{color:this.state.data.text_color, fontFamily: this.state.data.text_font}}>Texto texto texto texto texto texto</span>
                                                        <br/>
                                                        <span style={{color:this.state.data.main_color, fontFamily: this.state.data.text_font}}>$0.0</span>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell colSpan={2}>
                                            <Button primary fluid disabled={this.state.saving} loading={this.state.saving} content="Actualizar Información" onClick={this.saveDesign}/>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Grid.Column>

                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Table>
                                <Table.Row colSpan={2}>
                                    <div style={{textAlign:'center', padding:'1em'}}>
                                        <Message>
                                            <Message.Header>Advertencia</Message.Header>
                                            <p>
                                                Este código QR se verá afectado al cambiar la dirección web.
                                            </p>
                                        </Message>
                                        <QRCode value={`https://${this.state.data.slug}.bisttros.menu`} id="QRCode"/>
                                    </div>
                                </Table.Row>
                                <Table.Cell colSpan={2}>
                                    <Button primary fluid content="Descargar Código QR" onClick={this.downloadQrCode}/>
                                </Table.Cell>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>:<Grid.Row centered><Loading message={'Cargando...'}/></Grid.Row>}
                </Grid>
                
                <Modal size='tiny' dimmer='inverted' open={this.state.modal_web_address}>
                    <Modal.Header>Actualizar Enlace</Modal.Header>
                    <Modal.Content>
                            <Input
                                labelPosition='right'
                                type='text'
                                name={'slug'}
                                placeholder='Subdominio'
                                value={this.state.slug}
                                error={this.state.slug.trim() === ''}
                                onChange={this.handleChangeSlug}
                            >
                                <Label basic>https://</Label>
                                <input/>
                                <Label>.bisttros.menu</Label>
                            </Input>

                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.toggleModalSlug}>Cancelar</Button>
                        <Button primary content='Actualizar' onClick={this.saveSlug} disabled={this.state.saving_slug} loading={this.state.saving_slug}/>
                    </Modal.Actions>
                </Modal>

                <Modal size='tiny' dimmer='inverted' open={this.state.modal_domain}>
                    <Modal.Header>Actualizar Dominio</Modal.Header>
                    <Modal.Content>
                        <Input label='https://' placeholder='ejemplo.com'
                               name={'domain'}
                               value={this.state.domain}
                               onChange={this.handleChangeSlug}
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.toggleModalDomain}>Cancelar</Button>
                        <Button primary content='Actualizar' onClick={this.saveDomain} disabled={this.state.saving_domain} loading={this.state.saving_domain}/>
                    </Modal.Actions>
                </Modal>

                <CheckPermission access='website_edit'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(QuickMenu)



// WEBPACK FOOTER //
// ./src/containers/settings/QuickMenu.js